import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import { StatusBadge } from "../../../../../common/Badge";

const LeaveRecallHistory = ({ isOpen, onClose, data = [] }) => {
  const [currentPage, setCurrentPage] = useState(1);

  if (!isOpen) return null;

  const headers = [
    "Recall Ref No.",
    "Leave Ref No.",
    "Type",
    "Leave Period",
    "Days",
    "Status",
    "Reason",
    "Rejection Reason"
  ];

  const accessors = [
    "id",
    "leaveReferenceNumber",
    "leaveTypeDescription",
    "dateFrom",
    "days",
    "status",
    "reason",
    "reasonForRejection"
  ];

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit"
    });
  };

  const customRender = (row, accessor) => {
    if (accessor === "id") return `LRC-${row[accessor]?.toString().padStart(6, "0")}`;
    if (accessor === "leaveReferenceNumber") return row[accessor] ? `LV-${row[accessor]?.toString().padStart(6, "0")}` : "-";
    if (accessor === "dateFrom") {
      return `${formatDate(row.dateFrom)} - ${formatDate(row.dateTo)}`;
    }
    if (accessor === "status") {
      return <StatusBadge status={row[accessor]} />;
    }
    if (accessor === "reasonForRejection") {
      return row[accessor] || "-";
    }
    return null;
  };

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto">
      <div className="bg-gray-50 w-full md:w-[95%] lg:w-[85%] rounded-lg shadow-xl h-auto max-h-[90vh] flex flex-col relative">
        <div className="flex justify-between items-center px-6 py-3 border-b border-gray-200 bg-white rounded-t-lg">
          <h2 className="text-xl font-semibold text-gray-500 tracking-tight">Leave Recall History</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 bg-transparent border-none cursor-pointer">
            <CloseIcon fontSize="medium" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto">
          <CreateTable
            headers={headers}
            accessors={accessors}
            data={data}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={10}
            totalItems={data.length}
            customCellRenderer={customRender}
          />
        </div>

        <div className="flex justify-end p-4 border-t bg-white rounded-b-lg">
          <button onClick={onClose} className="bg-gray-500 text-white px-6 py-2 rounded cursor-pointer border-none">Close</button>
        </div>
      </div>
    </div>
  );
};

export default LeaveRecallHistory;